import { Divider } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';
import { SLOT_NAMES, slotNumberFromSlotName } from '../../utils/constants';
import type { SlotInfo } from './SwerveSlotRow';

interface SwerveSlotListProps {
  renderSlot: (slot: SlotInfo, slotKey: string) => React.ReactNode;
}

const SwerveSlotList = ({ renderSlot }: SwerveSlotListProps) => {
  const slotStorage = useSelector((state: RootState) => state.robotData.slotStorage) ?? {};

  return (
    <>
      {SLOT_NAMES.map((slotKey, listIndex) => {
        const slotNumber = slotNumberFromSlotName(slotKey);
        const slot: SlotInfo = slotStorage[slotKey] ?? { slotNumber, programTitle: '', isEmpty: true };
        return (
          <React.Fragment key={slotKey}>
            {renderSlot(slot, slotKey)}
            {listIndex < SLOT_NAMES.length - 1 && <Divider />}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default SwerveSlotList;
